// Clients can optionally provide the callbackTimeoutPeriod parameter
export type SchedulerOptions = {
	backoffFactor: number;
	backoffJitterPercentage: number;
	callbackTimeoutPeriod: number;
	maxRetryDelay: number;
	minRetryDelay: number;
	waitInterval: number;
};

export type OnDoneFn = {
	(state: DoneState): void;
};

export type OnTimeoutFn = {
	(): void;
};

export type CallbackFn = {
	(done: OnDoneFn): void;
};

export enum DoneState {
	NOOP,
	SUCCESS,
	ERROR,
}
